import { render, staticRenderFns } from "./GenericTaskCreationStep.vue?vue&type=template&id=680b1600"
import script from "./GenericTaskCreationStep.vue?vue&type=script&lang=js"
export * from "./GenericTaskCreationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports